import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { apiClient } from "./apiClient";
import { API_ROUTES, MINIMAL_SEARCH_CHARACTERS } from "../../constants";

export interface PeopleFinderPerson {
  confidence: number;
  department: string;
  firstName: string;
  functionDomain: string;
  lastName: string;
  officeCountry: string;
  opcoEmailAccount: string;
  opcoFunctionTitle: string;
  opcoLevel: string;
  ponCluster: string;
  ponEmailAccount: string;
  ponMobilePhone: string;
}

interface PeopleFinderResponse {
  response?: PeopleFinderPerson[];
}

export const QUERY_KEY = "getPeopleFinder";

export const usePeopleFinder = (params: {
  searchTerm: string;
  limit?: number;
}) => {
  return useQuery<PeopleFinderResponse, AxiosError>({
    queryKey: [QUERY_KEY, params.searchTerm],
    queryFn: async () => {
      const response = await apiClient.post<PeopleFinderResponse>(
        API_ROUTES.peopleFinder,
        {
          limit: params.limit,
          query: params.searchTerm,
        }
      );
      return response.data;
    },
    // Enable the query only if the search term is provided and has 3 or more characters.
    enabled:
      !!params.searchTerm &&
      params.searchTerm.length >= MINIMAL_SEARCH_CHARACTERS,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
